// extracted by mini-css-extract-plugin
export default {"wrapper":"mode-modal_wrapper__0UCxc","mode":"mode-modal_mode__-2d7E"};